import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/pageHeaderComponents/PageHeader';
import LocationsMainAddressForm from './LocationsMainAddressForm';
import LocationsAllAddressesList from './LocationsAllAddressesList';
import { FilterContextProvider } from '../../context/FilterContext';
import { ADDRESSES_PER_LARGE_PAGE, ADDRESSES_PER_PAGE } from '../../constants';
import { UIContext } from '../../context/UIContext';
import usePageTitle from '../../helperHooks/usePageTitle';

const Locations = () => {
  const { t } = useTranslation();
  const { isLargeDevice } = useContext(UIContext);
  const [isInFirstPage, setIsInFirstPage] = useState(true);

  usePageTitle('nav.locations');

  return (
    <>
      <PageHeader
        header={t(`steps.locations.header${isInFirstPage ? '1' : '2'}`)}
        description={t(`steps.locations.description${isInFirstPage ? '1' : '2'}`)}
      />

      {isInFirstPage ? (
        <LocationsMainAddressForm setIsInFirstPage={setIsInFirstPage} />
      ) : (
        <FilterContextProvider
          pageSize={isLargeDevice ? ADDRESSES_PER_LARGE_PAGE : ADDRESSES_PER_PAGE}
        >
          <LocationsAllAddressesList />
        </FilterContextProvider>
      )}
    </>
  );
};

export default Locations;
